
import { Segmented } from 'antd';
import { Modal, Divider, Row, Progress, Form, Drawer, Input, Button, Card, Tag, Mentions, } from 'antd';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { L } from '../../../../lib/abpUtility';
import AuthenticationStore from '../../../../stores/authenticationStore';
import Stores from '../../../../stores/storeIdentifier';
import Rules from '../../Validations/defaultValidations.validation';

export interface IScheduleDemoFormProps {
    visible: boolean;
    primaryColor: string;
    secondaryColor: string;
    isMobile: boolean;
    authenticationStore: AuthenticationStore;
    location: any;
    onCancel: () => void;
    onLogin: (values: any) => void;
    formRef: any;
}

export interface IScheduleDemoFormState {
    loading: boolean;
    day: any;
    time: any;
    zone: any;
}

@inject(Stores.AuthenticationStore)
@observer
class ScheduleDemoForm extends React.Component<IScheduleDemoFormProps, IScheduleDemoFormState> {
    state = {
        loading: false,
        day: 'Mon',
        time: 'Morning',
        zone: 'ET'
    };

    handleFinish = async (values: any) => {

        let updatedValues = {
            ...values,
            message: this.state.day + ' ' + this.state.time + ' ' + this.state.zone + ' | ' + values.message 
        }

        this.props.onLogin(updatedValues);
        this.props.formRef.current?.resetFields();
        this.props.onCancel();
    }

    render() {
        const { visible, isMobile, onCancel } = this.props;



        return (

            <div className="font-face-gm">

                <div>
                    <Modal
                        closable={this.props.isMobile === true ? true : false}
                        visible={isMobile === false ? (visible === true ? true : false) : false}
                        cancelText={L('Cancel')}
                        footer={null}
                        onCancel={onCancel}
                        title={null}>

                        <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                            {L('Schedule a Demo')}
                        </Divider>
                        <Row style={{ marginBottom: '10px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>
                        <p className="font-face-gm"  style={{margin: 'auto', textAlign: 'center'}}>{L('Schedule for week of')} <br /> {L('09/18/2022')} 
                                <br /> {L('Demo typically lasts 30 minutes')} <br /></p>
                        <Form ref={this.props.formRef}  style={{ marginTop: '0px', marginBottom: '0px' }} name={'ContactForm'} onFinish={(e) => this.handleFinish(e)}>
                            <Card className="font-face-gm" bordered={false} style={{ padding: '0px', marginTop: '0px', marginBottom: '-10px' }}>
                                <div style={{ marginBottom: '35px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Name')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'name'} rules={Rules.requiredString}  >
                                            <Input disabled={this.state.loading} size='large' prefix={''} placeholder={L('Name')} />
                                        </Form.Item>


                                    </div>
                                </div>
                                <br />

                                <div style={{ marginBottom: '35px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Email')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'email'} rules={[
                                                {
                                                  type: 'email',
                                                  required: true,
                                                  message: L('Please enter a valid email')
                                                },
                                              ]}  >
                                            <Input disabled={this.state.loading} size='large' prefix={''} placeholder={L('Email')} />
                                        </Form.Item>


                                    </div>
                                </div>

                                <br />
                                <div style={{ marginBottom: '35px', }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '0.9em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Time')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0', marginBottom: '10px' }}
                                            name={'day'} >
                                            <Segmented style={{ margin: 'auto' }} size="large" options={[L('Mon'), L('Tues'), L('Wed'), L('Thur'), L('Fri')]} onChange={(e) => this.setState({ day: e })} onResize={undefined} onResizeCapture={undefined} />

                                        </Form.Item>
                                        <Form.Item style={{ margin: '0', marginBottom: '10px', float: 'left' }}
                                            name={'time'} >
                                            <Segmented style={{ margin: 'auto' }} size="small" options={[L('Morning'), L('Afternoon'),]} onChange={(e) => this.setState({ time: e })} onResize={undefined} onResizeCapture={undefined}  />

                                        </Form.Item>

                                        <Form.Item style={{ margin: '0', marginBottom: '10px', float: 'left', marginLeft: '10px' }}
                                            name={'time'} >
                                            <Segmented defaultValue={L('ET')} style={{ margin: 'auto' }} size="small" options={[L('PT'), L('CT'), L('MT'), L('ET'), L('Other')]} onChange={(e) => this.setState({ zone: e })} onResize={undefined} onResizeCapture={undefined}  />

                                        </Form.Item>

                                    </div>
                                </div>

                                <br />
                                <div style={{ marginBottom: '60px', marginTop: '37px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '0.9em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Message')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'message'}    >
                                            <Mentions
                                                rows={2} style={{ width: '100%', textAlign: 'left' }}
                                                placeholder={L('...')}>
                                            </Mentions>
                                        </Form.Item>


                                    </div>
                                </div>
                                <br />



                               
                                <p className="font-face-gm"  style={{margin: 'auto', textAlign: 'center', fontSize: '0.9em', marginTop: '10px'}}> <br />{L('Please include notes regarding availability during the time slot selected. Once receieved, we will reach out to confirm as soon as possible.')} 
                               </p>







                                <div style={{ width: '100%', float: 'right', padding: '0', marginTop: '30px' }}>

                                    <Form.Item style={{ margin: '0', float: 'right' }}>
                                        <Button style={{ background: this.props.secondaryColor, borderColor: 'white' }} loading={this.state.loading} size='large' type="primary" shape='round' htmlType="submit" className="font-face-gm">
                                            {L('Submit')}
                                        </Button>
                                    </Form.Item>


                                </div>

                            </Card>

                        </Form>

                    </Modal>
                </div>


                <div>
                    <Drawer
                        closable={this.props.isMobile === true ? true : false}
                        onClose={onCancel}
                        visible={isMobile === true ? (visible === true ? true : false) : false}
                        footer={null}
                        width={isMobile === true ? (window.innerWidth * 0.9) : 420}
                        title={null} >
                       <Divider className="font-face-gm" type="horizontal" style={{ fontSize: this.props.isMobile === true ? '2em' : '2.3em', marginBottom: '0px' }} >
                            {L('Schedule a Demo')}
                        </Divider>
                        <Row style={{ marginBottom: '10px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>

                                <p className="font-face-gm"  style={{margin: 'auto', textAlign: 'center'}}>{L('Schedule for week of')} <br /> {L('09/18/2022')} 
                                <br /> {L('Demo typically lasts 30 minutes')} <br /></p>

                        <Form ref={this.props.formRef}  style={{ marginTop: '0px', marginBottom: '0px' }} name={'ContactForm'} onFinish={(e) => this.handleFinish(e)}>
                            <Card className="font-face-gm" bordered={false} style={{ padding: '0px', marginTop: '0px', marginBottom: '-10px' }}>

                                <div style={{ marginBottom: '55px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Name')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'name'} rules={Rules.requiredString}  >
                                            <Input disabled={this.state.loading} size='large' prefix={''} placeholder={L('Name')} />
                                        </Form.Item>


                                    </div>
                                </div>


                                <div style={{ marginBottom: '65px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Email')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'email'} rules={[
                                                {
                                                  type: 'email',
                                                  required: true,
                                                  message: L('Please enter a valid email')
                                                },
                                              ]} >
                                            <Input disabled={this.state.loading} size='large' prefix={''} placeholder={L('Email')} />
                                        </Form.Item>


                                    </div>
                                </div>

                                <br /> <br />
                                <div style={{ marginBottom: '60px', }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '0.9em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Time')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0', marginBottom: '10px' }}
                                            name={'day'} >
                                            <Segmented style={{ margin: 'auto' }} size="small" options={[L('Mon'), L('Tues'), L('Wed'), L('Thur'), L('Fri')]} onChange={(e) => this.setState({ day: e })} onResize={undefined} onResizeCapture={undefined} />

                                        </Form.Item>
                                        <Form.Item style={{ margin: '0', marginBottom: '10px', float: 'left' }}
                                            name={'time'} >
                                            <Segmented style={{ margin: 'auto' }} size="small" options={[L('Morning'), L('Afternoon'),]} onChange={(e) => this.setState({ time: e })} onResize={undefined} onResizeCapture={undefined} />

                                        </Form.Item>

                                        <Form.Item style={{ margin: '0', marginBottom: '10px', float: 'left', marginLeft: '10px' }}
                                            name={'time'} >
                                            <Segmented defaultValue={L('ET')} style={{ margin: 'auto' }} size="small" options={[L('PT'), L('CT'), L('MT'), L('ET'), L('Other')]} onChange={(e) => this.setState({ zone: e })} onResize={undefined} onResizeCapture={undefined} />

                                        </Form.Item>

                                    </div>
                                </div>

                                <br />
                                <div style={{ marginBottom: '10px', marginTop: '45px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '0.9em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Message')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'message'}    >
                                            <Mentions
                                                rows={2} style={{ width: '100%', textAlign: 'left' }}
                                                placeholder={L('...')}>
                                            </Mentions>
                                        </Form.Item>


                                    </div> <br />
                                </div>

                                <br />
                                <p className="font-face-gm"  style={{margin: 'auto', textAlign: 'center', fontSize: '0.9em', marginTop: '10px'}}> <br />{L('Please include notes regarding availability during the time slot selected. Once receieved, we will reach out to confirm as soon as possible.')} 
                               </p>

                                

                                <div style={{ width: '100%', margin: 'auto', textAlign: 'center', padding: '0', marginTop: '30px' }}>

                                    <Form.Item >
                                        <Button loading={this.state.loading} size='large'
                                            type="primary" shape='round' htmlType="submit"
                                            className="font-face-gm" style={{ background: this.props.secondaryColor, borderColor: 'white' }}>
                                            {L('Submit')}
                                        </Button>
                                    </Form.Item>


                                </div>

                            </Card>

                        </Form>

                    </Drawer>
                </div>


            </div>
        );
    }

}

export default ScheduleDemoForm;